
import _ from 'lodash'

export default {
    props: {
        title: { type: String, required: true },
        icon: { type: String, required: true },
        items: { type: Array, required: true },
        countNoun: { type: String, default: 'added' },
        searchPlaceholder: { type: String, default: 'Search…' },
        optOutLabel: { type: String, required: true },
        optOut: { type: Boolean, default: false },
        itemNoun: { type: String, required: true },
        itemNounPlural: { type: String, required: true },
        manualLabel: { type: String, default: null },
        // Count of LIVE search results (not `items`). Consumers that pass this
        // get the connected-dropdown treatment once results arrive; a
        // consumer that leaves it at the default 0 keeps the plain host +
        // always-visible dashed manual button, unchanged.
        resultsCount: { type: Number, default: 0 },
        // Minimum characters typed before a search fires. Default 2 matches
        // every existing consumer's expectation (Doctors/Hospitals/
        // Medications all search real names, where a single letter returns
        // too much). PharmacyStep opts into 1 (task-d2 brief, matching the
        // MedicareCheckup platform's StepPharmacy.vue: `q.trim().length >= 1`)
        // since pharmacy chains ("CVS") are short and zip-scoped already
        // limits result volume.
        minQueryLength: { type: Number, default: 2 },
    },
    data () {
        return { query: '', manualOpen: false, confirming: false }
    },
    watch: {
        query (q) {
            this.debouncedSearch(q)
        },
        optOut () {
            this.confirming = false
        },
    },
    created () {
        // Per-instance debounce — an options-level _.debounce is shared across
        // all mounted GuidanceCard instances, so typing in multiple instances
        // within 300ms silently drops early emits.
        this.debouncedSearch = _.debounce((q) => {
            this.$emit('search', (q || '').trim().length >= this.minQueryLength ? q.trim() : '')
        }, 300)
    },
    methods: {
        clearSearch () {
            this.query = ''
            this.$emit('search', '')
        },
        closeManual () { this.manualOpen = false },
        toggleManual () { this.manualOpen = !this.manualOpen },
        onOptOutClick () {
            if (this.optOut) {
                this.$emit('opt-out', false)
                return
            }
            if (!this.items.length) {
                this.$emit('opt-out', true)
                return
            }
            this.confirming = true
        },
        confirmClear () {
            this.confirming = false
            this.$emit('clear-and-opt-out')
        },
    },
}
